import { Box } from '@mui/material';
import { useSelector } from 'react-redux';

import {
  FavoritesIcon,
  HomeIcon,
  ManageFirmIcon,
  ManageVideosIcon,
  OfficeIcon,
  SettingsBar,
  SharedIcon,
} from 'src/components/icons';
import { getRolesForPath } from 'src/navigation/utils';
import {
  selectUserFirm,
  useNotificationsUnreadCountQuery,
} from 'src/services/user';
import { ManageCollectionsIcon } from '../icons/ManageCollections';
import { Statistics } from '../icons/Statistics';
import { Videos } from '../icons/Videos';
import { DrawerLinkProps } from './DrawerLink';

const NotifyIcon = () => {
  const { data: notificationsUnreadCount } = useNotificationsUnreadCountQuery();
  return notificationsUnreadCount ? (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '22px',
        minWidth: '22px',
        height: '22px',
        bgcolor: '#D7335C',
        borderRadius: '50%',
        fontSize: '10px',
        color: '#ffffff',
      }}
    >
      {notificationsUnreadCount > 99 ? '99+' : notificationsUnreadCount}
    </Box>
  ) : null;
};

export const useDrawerLinks = () => {
  const userFirm = useSelector(selectUserFirm);

  return [
    {
      icon: HomeIcon,
      match: '/',
      title: 'Home Page',
      to: '/',
    },
    {
      roles: getRolesForPath('/collections'),
      icon: Videos,
      match: '/collections',
      title: 'Collections',
      to: '/collections',
    },
    {
      disableForSuperAdmin: true,
      icon: SharedIcon,
      notifyIcon: <NotifyIcon />,
      roles: getRolesForPath('/shared-with-me'),
      title: 'Shared with Me',
      to: '/shared-with-me',
    },
    {
      disableForSuperAdmin: true,
      icon: FavoritesIcon,
      title: 'My Favorites',
      roles: getRolesForPath('/my-favorites'),
      to: '/my-favorites',
    },
    {
      disableForSuperAdmin: true,
      icon: ManageFirmIcon,
      iconSx: { fontSize: '24px', marginLeft: '-2px' },
      match: '/manage-firms/*',
      roles: getRolesForPath('/manage-firms/:id'),
      title: 'Manage Firm',
      to: `/manage-firms/${userFirm?.id}`,
    },
    {
      icon: ManageFirmIcon,
      iconSx: { fontSize: '24px', marginLeft: '-2px' },
      roles: getRolesForPath('/manage-firms'),
      title: 'Manage firms',
      to: '/manage-firms',
    },
    {
      icon: ManageVideosIcon,
      roles: getRolesForPath('/manage-videos'),
      title: 'Manage videos',
      to: '/manage-videos',
    },
    {
      icon: ManageCollectionsIcon,
      roles: getRolesForPath('/manage-collections'),
      title: 'Manage collections',
      to: '/manage-collections',
    },
    {
      icon: SettingsBar,
      roles: getRolesForPath('/settings'),
      title: 'Settings',
      to: '/settings',
    },
    {
      icon: Statistics,
      roles: getRolesForPath('/statistics'),
      title: 'Statistics',
      to: '/statistics',
    },
    {
      icon: OfficeIcon,
      roles: getRolesForPath('work-better.com'),
      isExternalLink: true,
      title: 'work-better.com',
      to: 'https://www.work-better.com/',
    },
  ] as DrawerLinkProps[];
};
